import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsightPerception = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 11C2 11 8.26801 4 16 4C23.7319 4 30 11 30 11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.3616 17.2039C29.7872 17.7825 30 18.0718 30 18.5C30 18.9282 29.7872 19.2175 29.3616 19.7961C27.4491 22.3958 22.5649 28 16 28C9.43509 28 4.55094 22.3958 2.63846 19.7961C2.21281 19.2175 2 18.9282 2 18.5C2 18.0718 2.21281 17.7825 2.63846 17.2039C4.55094 14.6042 9.43509 9 16 9C22.5649 9 27.4491 14.6042 29.3616 17.2039Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 18.5C20 16.2908 18.2092 14.5 16 14.5C13.7908 14.5 12 16.2908 12 18.5C12 20.7092 13.7908 22.5 16 22.5C18.2092 22.5 20 20.7092 20 18.5Z",
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
export default SvgInsightPerception;
